// "Ödəniş al / Ödəniş" düymələrinin görünmə şərti — tək mənbə.
//
// Ödəniş qəbulu ayrıca Spatie icazəsi tələb edir. Ofisiantın default rol dəstində
// (tables.view, table-orders.view/add-item/remove-item, table-order) ödənişlə bağlı
// HEÇ BİR icazə yoxdur; kassirdə isə payments.process + manage-payments var.
// Bax: rezmo_backend/database/seeders/RolePermissionSeeder.php → defaultRoleConfigs().

import { usePermissions } from '../context/PermissionsContext';

const PAYMENT_PERMISSIONS = ['payments.process', 'manage-payments'];

// İcazə siyahısı boşdursa (offline giriş / prod-da rola icazə təyin edilməyib)
// rol adına görə qərar veririk. Qəsdən AĞ SİYAHI-dır, qara siyahı deyil: naməlum
// yaxud custom rol (məs. "satis-operatoru") ödəniş ala bilməz. Əks halda icazəsi
// olmayan hər yeni rol düyməni görərdi.
const PAYMENT_ROLE_KEYS = new Set([
  'cashier',
  'kassir',
  'manager',
  'menecer',
  'admin',
  'owner',
  'super-admin',
  'superadmin',
]);

export function useCanTakePayment(): boolean {
  const { hasPermission, permissions, role } = usePermissions() as {
    hasPermission: (p: string[] | string) => boolean;
    permissions: string[];
    role: string | null;
  };

  if (permissions.length > 0) return hasPermission(PAYMENT_PERMISSIONS);
  return PAYMENT_ROLE_KEYS.has(String(role || '').trim().toLowerCase());
}
